<template>
  <v-data-table
    :items="data"
    :headers="headers"
    :loading="loading"
    :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'mdi-arrow-collapse-left',
      lastIcon: 'mdi-arrow-collapse-right',
      prevIcon: 'mdi-minus',
      nextIcon: 'mdi-plus'
    }"
    class="elevation-1 admin-table"
    loading-text="Loading... Please wait"
  >
    <template v-slot:item.actions="{item}">
      <div class="reports-action-launch" @click="launchRowAction">
        <v-icon>mdi-dots-vertical</v-icon>
        <ActionContainer :ref="item.key" :heading="'Action'" class="report-action-options">
           <ActionItem 
            label="Update OTC"
            icon="mdi-link"
            @click.native="updateOTC(item)"/>
          <ActionItem 
            :disabled="!$can('deleteDevice')"
            label="Delete"
            icon="mdi-delete"
            @click.native="deleteDevice(item)"/>
        </ActionContainer>
      </div>
    </template>
  </v-data-table>
</template>

<script>

import ActionContainer from '@/components/general/ActionContainer.vue';
import ActionItem from '@/components/general/ActionItem.vue';

export default {
  name: 'PendingDevicesTable',
  components: {
    ActionContainer,
    ActionItem
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'OTC',
          value: 'Profile.otc',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'left'
        }
      ],
      selected: []
    }
  },
  methods: {
    launchRowAction(e) {
      let allOptions = document.querySelectorAll(".report-action-options");

      for (let option of allOptions) {
        option.classList.remove('active-options');
        if (option === e.target.nextSibling) {
          option.classList.toggle('active-options');
        } 
      }
    },
    unassignDevice(item) {
      this.$emit('unassignDevice', item);
    },
    showInfoModal(item) {
      this.$emit('showInfoModal', item);
    },
    toggleAssignmentComp() {
      this.$emit('toggleAssignmentComp');
    },
    updateOTC(item) {
      this.$emit('updateOTC', item);
    },
    deleteDevice(item) {
      this.$emit('deleteDevice', item, 'pending');
    }
  }
}
</script>

<style lang="scss">

</style>